import { USE_API_MOCKS } from 'src/env';
import { RESTClientMock, RESTClient } from './client';

import { API_URL } from './apiDictionary';
import {
  QCTaskDefinition,
  QCTaskDefinitionStatus,
} from '@dynamika-shared/types/qcTaskDefinitions';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export const fetchQCTaskDefinitions = async (
  patientId: string,
  visitId: string,
  clinicalTrialId: string
) => {
  return api.get<QCTaskDefinition[]>(`${API_URL.qcTaskDefinition}`, {
    params: {
      patientId,
      visitId,
    },
    headers: {
      'x-dynamika-clinical-trial-id': clinicalTrialId,
    },
    id: 'get-qc-task-definitions',
  });
};

export const fetchQCTaskDefinitionStatus = async (
  taskDefinitionId: string,
  patientId: string,
  visitId: string,
  clinicalTrialId: string
) => {
  return api.get<QCTaskDefinitionStatus>(
    API_URL.qcTaskDefinitionsStatus.replace(
      ':taskDefinitionId',
      taskDefinitionId
    ),
    {
      params: {
        patientId: patientId,
        visitId: visitId,
      },
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
      id: 'get-qc-task-definitions-status',
    }
  );
};

export const updateQCTaskDefinition = async (
  taskDefinitionId: string,
  clinicalTrialId: string,
  data: {
    patientId: string;
    visitId: string;
    comment: string;
  }
) => {
  return api.put<QCTaskDefinition>(
    API_URL.qcTaskDefinitionsUpdate.replace(
      ':taskDefinitionId',
      taskDefinitionId
    ),
    data,
    {
      headers: {
        'x-dynamika-clinical-trial-id': clinicalTrialId,
      },
      id: 'put-qc-task-definitions',
    }
  );
};
